<template>
  <el-dialog
    :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
    :visible.sync="dialogVisible"
    width="700px"
  >
    <!-- <el-col :span="3">{{ $t("app.bedTags.schoolYear") }}:</el-col> -->
    <el-input
      v-model="schoolYear"
      size="small"
      style="margin-bottom: 20px; width: 100%"
      :placeholder="$t('app.bedTags.schoolYear')"
    >
    </el-input>
    <!-- <el-input
      v-model="code"
      size="small"
      style="margin-bottom: 20px; width: 100%"
      :placeholder="$t('app.bedTags.code')"
    >
    </el-input>
    <el-input
      size="small"
      style="margin-bottom: 20px; width: 100%"
      v-model="name"
      :placeholder="$t('app.bedTags.name')"
    > 
    </el-input>-->
    <el-select
      v-model="isUse"
      size="small"
      style="margin-bottom: 20px; width: 100%"
      :placeholder="$t('app.validation.select') + $t('app.enable')"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-input
      size="small"
      style="margin-bottom: 20px"
      v-model="description"
      :placeholder="$t('app.bedTags.description')"
    >
    </el-input>
    <!--
    <el-label>複製標籤項內容: </el-label>
    <el-select
      v-model="isUse2"
      size="small"
      style="margin-bottom: 20px; width: 50%"
      placeholder="請選擇要複製的學年"
    >
    </el-select>
    -->
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { addParent, update } from "@/api/systemManagement/bedTagsManagement";
export default {
  data() {
    return {
      code: "",
      schoolYear: "",
      name: "",
      isUse: null,
      description: "",
      options: [
        {
          value: true,
          label: this.$t("app.isUse")
        },
        {
          value: false,
          label: this.$t("app.disable")
        }
      ],

      loading: false,
      dialogVisible: false,
      index: "",
      type: "",
      modalInfor: {}
    };
  },
  methods: {
    edit(index, row) {
      //console.log(row);
      this.modalInfor = row;
      this.dialogVisible = true;
      this.Code = row.Code;
      this.schoolYear = row.SchoolYear;
      this.name = row.Name;
      this.isUse = row.enable;
      this.description = row.Description;
      this.index = index;
      (this.sort = row.sort), (this.type = "edit");
    },
    add() {
      this.dialogVisible = true;
      this.type = "new";
      this.schoolYear = "";
      this.code = "";
      this.name = "";
      this.index = "";
      this.isUse = null;
      this.description = "";
      this.sort = "99";
    },
    handleClose() {
      this.$confirm(
        (this.type === "edit"
          ? this.$t("app.confirmModification")
          : this.$t("app.confirmAdd")) + "?"
      ).then(() => {
        this.loading = true;
        if (this.type === "edit") {
          console.log(this.isUse);
          update({
            SchoolYear: this.schoolYear,
            Code: this.code,
            Name: this.name,
            Description: this.description,
            IsUse: this.isUse ? "true" : "false",
            Id: this.modalInfor.Id,
            Pid: this.modalInfor.Pid
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          addParent({
            SchoolYear: this.schoolYear,
            Code: this.code,
            Name: this.name,
            IsUse: this.isUse ? "true" : "false",
            Description: this.description
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
          // .then(res => {
          //   console.log(res);
          //   addChild({
          //     Code: this.code,
          //     Name: this.name,
          //     Description: this.description,
          //     IsUse: this.isUse,
          //     SortNumber: this.sort,
          //     Pid: res.data
          //   })
          //     .then(() => {
          //       this.success();
          //     })
          //     .catch(() => {
          //       this.loading = false;
          //     });
          // });
        }
      });
    },
    success() {
      this.loading = false;
      this.dialogVisible = false;
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success"
      });
      this.$emit("handleSuccess");
    }
  }
};
</script>
